const LocaleAndCurrency = Object.freeze({
    "US": {
        locale: "en_US",
        currency: "USD",
    },
    "CA": {
        locale: "en_CA",
        currency: "CAD",
    },
    "EU": {
        locale: "en_EU",
        currency: "EUR",
    },
    "AU": {
        locale: "en_AU",
        currency: "AUD",
    },
    "SG": {
        locale: "en_SG",
        currency: "SGD",
    },
    "FR": {
        locale: "fr_FR",
        currency: "EUR",
    },
    "GB": {
        locale: "en_GB",
        currency: "GBP",
    },
    "BM": {
        locale: "en_GB",
        currency: "GBP",
    },
    "DE": {
        locale: "de_DE",
        currency: "EUR",
    },
    "LI": {
        locale: "de_DE",
        currency: "EUR",
    },
    "ES": {
        locale: "es_ES",
        currency: "EUR",
    },
    "IT": {
        locale: "it_IT",
        currency: "EUR",
    },
    "JP": {
        locale: "ja_JP",
        currency: "JPY",
    },
    "TW": {
        locale: "zh_TW",
        currency: "TWD",
    },
    "VN": {
        locale: "vi_VN",
        currency: "VND",
    },
    "KR": {
        locale: "ko_KR",
        currency: "KRW",
    },
    "MX": {
        locale: "es_MX",
        currency: "MXN",
    },
    "BR": {
        locale: "pt_BR",
        currency: "BRL",
    },
    "AT": {
        locale: "en_EU",
        currency: "EUR",
    },
    "BE": {
        locale: "en_EU",
        currency: "EUR",
    },
    "BG": {
        locale: "en_EU",
        currency: "EUR",
    },
    "HR": {
        locale: "en_EU",
        currency: "EUR",
    },
    "CY": {
        locale: "en_EU",
        currency: "EUR",
    },
    "CZ": {
        locale: "en_EU",
        currency: "EUR",
    },
    "DK": {
        locale: "en_EU",
        currency: "EUR",
    },
    "EE": {
        locale: "en_EU",
        currency: "EUR",
    },
    "FI": {
        locale: "en_EU",
        currency: "EUR",
    },
    "GR": {
        locale: "en_EU",
        currency: "EUR",
    },
    "HU": {
        locale: "en_EU",
        currency: "EUR",
    },
    "IE": {
        locale: "en_EU",
        currency: "EUR",
    },
    "LV": {
        locale: "en_EU",
        currency: "EUR",
    },
    "LT": {
        locale: "en_EU",
        currency: "EUR",
    },
    "LU": {
        locale: "en_EU",
        currency: "EUR",
    },
    "MT": {
        locale: "en_EU",
        currency: "EUR",
    },
    "NL": {
        locale: "en_EU",
        currency: "EUR",
    },
    "PT": {
        locale: "en_EU",
        currency: "EUR",
    },
    "RO": {
        locale: "en_EU",
        currency: "EUR",
    },
    "SK": {
        locale: "en_EU",
        currency: "EUR",
    },
    "SI": {
        locale: "en_EU",
        currency: "EUR",
    },
    "SE": {
        locale: "en_EU",
        currency: "EUR",
    },
    "IS": {
        locale: "en_EU",
        currency: "EUR",
    },
    "AE": {
        locale: "en_ME",
        currency: "USD",
    },
    "HK": {
        locale: "en_HK",
        currency: "HKD",
    },
    "PH": {
        locale: "en_PH",
        currency: "PHP",
    },
    "PL": {
        locale: "pl_PL",
        currency: "PLN",
    },
    "NO": {
        locale: "nb_NO",
        currency: "NOK",
    },
    "MA": {
        locale: "en_AF",
        currency: "USD",
    },
    "TN": {
        locale: "en_AF",
        currency: "USD",
    },
    "CR": {
        locale: "es_LA",
        currency: "USD",
    },
    "DO": {
        locale: "es_LA",
        currency: "USD",
    },
    "GT": {
        locale: "es_LA",
        currency: "USD",
    },
    "PA": {
        locale: "es_LA",
        currency: "USD",
    },
    "PR": {
        locale: "es_LA",
        currency: "USD",
    },
})

export default LocaleAndCurrency;